import type { ButtonConfig } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Modal, Button } from 'antd'
import { EasyIcon, ListPropsContext, postMsg } from 'src/components'
import { listStore } from 'src/stores'
import { $api } from 'src/plugins'

type Props = {
  config: ButtonConfig
}

const DeleteConfirmBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const handleDelete = () => {
    const { BATCH_DEL_API_URL: url } = table?.tableConfig?.PageTable || {}
    if (!url) {
      postMsg('未配置批量删除API接口', 'error')
      return
    }
    const records = table.selectedData
    const names = records.map((item: any) => item.NAME).filter((item: any) => !!item).slice(0, 3)
    const delLabel = names.length ? names.join('、') : ''
    Modal.confirm({
      title: '批量删除',
      content: `确认删除${delLabel}等${records.length}项数据？`,
      onOk: () => {
        $api['app/getDataByGet'](
          { ids: records.map((item: any) => item.ID).join(',') },
          { url }
        ).then((res: any) => {
          if (res) {
            table.reload()
            postMsg('删除成功')
          }
        }).finally(() => {
          table.setSelectedKeys([])
        })
      }
    })
  }

  const [disabled, setDisabled] = useState(false)
  useEffect(() => autorun(() => {
    setDisabled(!table?.selectedData?.length)
  }), [])

  const { config } = props
  const { LABEL, ICON } = config
  return (
    <Button
      danger
      disabled={disabled}
      icon={<EasyIcon type={ICON} defaultIcon='DeleteOutlined' />}
      onClick={handleDelete}
    >{LABEL}</Button>
  )
}

export default DeleteConfirmBtn